<template>
  <footer class="footer bg-light">
    <div class="container">
      <div class="row text-center align-items-center">

        <div class="col-12 col-md-3 col-lg-2">
          {{ versao }}
        </div>

        <div class="col-12 col-md">
          &copy; Prefeitura Municipal de Belo Horizonte
        </div>

        <div class="col-12 col-md-3 col-lg-2 text-center">
          <img :src="logoURL" class="img-fluid logo-footer" alt="Prefeitura de Belo Horizonte">
        </div>

      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Rodape",
  props: {
    logoURL: { type: String, default: "" },
    versao: { type: String, default: "" },
  }
};
</script>

<style scoped>
.logo-footer {
  max-height: 50px;
}
</style>
